<template>
  <div class="home">
    <!-- 成绩查询 悬浮窗 -->
    <!-- <div class="queryFixed" @click="queryList"><p>成绩查询</p></div> -->
    <!-- 顶部轮播图 -->
    <div class="maininfo">
      <!-- <el-carousel :autoplay = "true" :interval="15000" > -->
      <div class="banner-wrap">
        <el-carousel v-if="imgone.length > 0" :autoplay="true" :interval="10000" height="375px">
          <el-carousel-item v-for="item in imgone" :key="item.bannerId">
            <img :src="item.imgPath" alt="" @click="topage(item)" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 赛事专区新闻（左） + 公告资讯（右） 双栏布局（2026-08-31） -->
    <div class="listinfo">
      <div class="widthSet">
        <!-- 左侧：赛事专区新闻 -->
        <div class="match-news">
          <div class="top">
            <div class="leftson">
              <h3>赛事专区</h3>
              <p>
                <span>MATCH</span> <span class="green">ZONE</span>
              </p>
            </div>
            <div class="rightson more-match" @click="tomatch">
              <p>更多赛事</p>
              <button>
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>

          <!-- 赛事新闻列表：点击进入赛事详情 -->
          <ul class="matchnotice">
            <li
              class="itemshadow aniMate"
              v-for="item in matchlist"
              :key="item.matchId"
              @click="goMatchDetails(item)"
            >
              <span class="info-tag tag-match">赛事专区</span>
              <p class="maxwidth">{{ item.matchName }}</p>
              <span
                class="match-status"
                :class="'mst-' + item.matchStatus"
                v-if="matchStatusName(item.matchStatus)"
                >{{ matchStatusName(item.matchStatus) }}</span
              >
            </li>
            <li v-if="matchlist.length === 0" class="itemshadow">
              <p>暂无赛事</p>
            </li>
          </ul>
        </div>

        <!-- 右侧：协会公告 + 新闻资讯 统一列表（类型标签区分，发布时间倒序） -->
        <div class="infocenter">
          <div class="top">
            <div class="leftson">
              <h3>资讯动态</h3>
              <p>
                <span>ANNOUNCEMENT</span> <span class="green">&amp; NEWS</span>
              </p>
            </div>
            <div class="rightson-group">
              <div class="rightson more-notice" @click="tonotice">
                <p>公告列表</p>
                <button>
                  <i class="el-icon-arrow-right"></i>
                </button>
              </div>
              <div class="rightson more-news" @click="tonews">
                <p>新闻列表</p>
                <button>
                  <i class="el-icon-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- 统一内容列表：协会公告与新闻资讯混排，按发布时间倒序 -->
          <ul class="newnotice">
            <li
              class="itemshadow aniMate"
              v-for="item in mixedList"
              :key="item.type + '-' + item.rowKey"
              @click="openInfo(item)"
            >
              <span class="info-tag" :class="item.type === 'notice' ? 'tag-notice' : 'tag-news'">
                {{ item.type === 'notice' ? '协会公告' : '新闻资讯' }}
              </span>
              <p class="maxwidth">{{ item.title }}</p>
              <p class="infodate">{{ item.publishDate | yymmdd }}</p>
            </li>
            <li v-if="mixedList.length === 0" class="itemshadow">
              <p>暂无内容</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 四大专栏入口（协会专栏已按需求于 2026-08-31 隐藏：所有设备不可见，后续如需恢复取消注释即可）
    <div class="columns">
      <div class="columns-inner">
        <div class="columns-head">
          <h3>协会专栏</h3>
          <p><span>SPECIAL</span> <span class="green">COLUMNS</span></p>
        </div>

        <ul class="columns-grid">
          <li class="column-card" @click="goEchelon">
            <div class="col-top">
              <span class="col-ico ico-blue"><i class="el-icon-trophy"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>运动员梯队专栏</h4>
            <p class="col-en">ATHLETE ECHELON</p>
            <p class="col-desc">梯队选拔办法、入选名单、集训安排、晋升规则公示</p>
          </li>

          <li class="column-card" @click="goCertificate">
            <div class="col-top">
              <span class="col-ico ico-green"><i class="el-icon-medal"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>裁判&教练员资质专栏</h4>
            <p class="col-en">REFEREE & COACH</p>
            <p class="col-desc">持证裁判员、教练员名录公示，可核验证书真伪</p>
          </li>

          <li class="column-card" @click="goKnowledge">
            <div class="col-top">
              <span class="col-ico ico-teal"><i class="el-icon-reading"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>科学科普/训练干货</h4>
            <p class="col-en">TRAINING GUIDE</p>
            <p class="col-desc">跳绳基础训练、速度跳教程、青少年体能提升方案</p>
          </li>

          <li class="column-card" @click="goCertApply">
            <div class="col-top">
              <span class="col-ico ico-amber"><i class="el-icon-document"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>证书管理入口</h4>
            <p class="col-en">CERTIFICATE SERVICE</p>
            <p class="col-desc">运动员/裁判员/教练员证线上申领、补办、年审</p>
          </li>
        </ul>
      </div>
    </div>
    -->

    <!-- 成果展示（滚动照片） -->
    <div class="achievementinfo">
      <div class="ach-wrap">
        <div class="ach-marquee" v-if="achievementList.length > 0">
          <div class="ach-track">
            <div class="ach-item" v-for="a in achievementList" :key="a.id">
              <img :src="a.image" :alt="a.title" />
              <span class="ach-title">{{ a.title }}</span>
            </div>
            <div class="ach-item" v-for="a in achievementList" :key="'dup-' + a.id">
              <img :src="a.image" :alt="a.title" />
              <span class="ach-title">{{ a.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="partinfo">
      <p>沈阳市跳绳协会合作伙伴</p>
      <!-- <p>Cooperative partner  OOPERATIVE PARTNER</p> -->
      <p>COOPERATIVE PARTNER</p>
    </div>

    <!-- 底部轮播图  -->
    <div class="footerinfo">
      <ul class="footul">
        <li
          class="footli cursorPointer"
          v-for="item in imgtwo"
          :key="item.id"
          @click="toLink(item.linkPath)"
        >
          <img :src="item.imgPath" alt="" />
          <span class="partnerName">{{ item.partnerName }}</span>
        </li>
      </ul>

      <!-- <div class="prev" @click='go("prev")'>
        <button><i class="el-icon-arrow-left"></i></button>
      </div>
      <div>
        <el-carousel ref="cardshow" height="150px" :autoplay = "true" :interval="4000" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgtwo" :key="item.id" >
            <img :src="item.src" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="next" @click='go("next")'>
        <button><i class="el-icon-arrow-right"></i></button>
      </div> -->
      <a
        ref="aclick"
        v-show="false"
        target="_blank"
        href="https://www.chesscoacher.com/"
        >众弈世界</a
      >
    </div>
  </div>
</template>

<script>
  import request from '../utils/request'
  export default {
    name: 'Home',
    components: {},
    data() {
      return {
        noticelist: [
        ], //协会公告（统一列表数据源）
        newslist: [], //新闻资讯（统一列表数据源）
        matchlist: [], //赛事专区新闻（数据源 /pub/match/list）
        // banner虚拟数据
        imgone: [],
        // 成果展示
        achievementList: [],

        // 底部合作伙伴
        imgtwo: [

          {
            id: 2,
            name: "优尔",
            src: require("@/assets/bannerall/yr.png")
          },
          {
            id: 4,
            name: "众弈",
            src: require("@/assets/bannerall/zy.png")
          },
          {
            id: 5,
            name: "跳绳俱乐部",
            src: require("@/assets/bannerall/mf.png")
          },
          {
            id: 3,
            name: "沈阳棋院",
            src: require("@/assets/bannerall/syqy.png")
          },

          {
            id: 1,
            name: "基金会",
            src: require("@/assets/bannerall/jjh.png")
          },
        ],
      }
    },
    computed: {
      // 统一内容列表：协会公告与新闻资讯合并，按发布时间倒序（最新优先），取前 10 条
      mixedList() {
        const notices = this.noticelist.map(n => ({
          type: 'notice',
          rowKey: n.noticeId,
          title: n.title,
          publishDate: n.publishDate,
          raw: n
        }))
        const news = this.newslist.map(n => ({
          type: 'news',
          rowKey: n.newId,
          title: n.title,
          publishDate: n.publishDate,
          raw: n
        }))
        return [...notices, ...news]
          .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
          .slice(0, 10)
      }
    },
    created() {
      this.$store.commit("updatetabIndexActive", "1")
      // 进入页面 就将页面滚动到最顶部   可以解决多个路由页面共用一个滚动容器的bug
      document.documentElement.scrollTop = 0
      // 请求banner数据
      this.getbanner()
      // 请求partner数据
      this.getPartner()
      // 请求协会公告列表
      this.getnoticedata()
      // 请求新闻资讯列表
      this.getnewsdata()
      // 请求赛事专区新闻
      this.getmatchdata()
      // 请求成果展示
      this.getAchievements()
      // 测试数组截取
      // this.handlelist()
    },

    methods: {
      // 获取成果展示
      async getAchievements() {
        try {
          const { data } = await request({
            method: 'get',
            url: `/achievement/pub/list`,
            params: { pageNum: 1, pageSize: 50 }
          })
          this.achievementList = (data.code === 200 && data.rows) ? data.rows : []
        } catch (e) {
          this.achievementList = []
        }
      },
      // 悬浮成绩查询
      queryList() {

        // 跳转至赛事活动页
        this.$router.push({
          name: "move",
          query: {
            queryRandomNum: 1
          }
        })
        this.$store.commit("updatetabIndexActive", "3")

      },
      // 获取协会公告列表
      async getnoticedata() {
        try {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/NoticeInfo/list`,
          })
          if (data.code === 200 && data.rows) {
            this.noticelist = data.rows.slice(0, 10) //统一列表数据源（合并后按时间倒序取前10）
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取赛事列表失败")
          }
        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },
      // 获取新闻资讯列表
      async getnewsdata() {
        try {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/NewsInfo/list`,
          })
          if (data.code === 200 && data.rows) {
            // 统一列表数据源（合并后按时间倒序取前10）
            this.newslist = data.rows.slice(0, 10)
          } else {
            this.newslist = []
          }
        } catch (e) {
          this.newslist = []
        }
      },

      // 获取赛事专区新闻列表（复用赛事中心 /pub/match/list 数据源）
      async getmatchdata() {
        try {
          const { data } = await request({
            method: 'get',
            url: `/pub/match/list`,
            params: { pageNum: 1, pageSize: 10 }
          })
          if (data.code === 200 && data.rows) {
            this.matchlist = data.rows.slice(0, 10)
          } else {
            this.matchlist = []
          }
        } catch (e) {
          this.matchlist = []
        }
      },

      // 赛事状态文案：1=报名中 2=进行中 3=已结束
      matchStatusName(status) {
        if (status == 1) return '报名中'
        if (status == 2) return '进行中'
        if (status == 3) return '已结束'
        return ''
      },

      // 点击赛事新闻：拉取详情并跳转到赛事详情页
      async goMatchDetails(item) {
        document.documentElement.scrollTop = 0
        try {
          const { data } = await request({
            method: 'get',
            url: `/pub/match/detail`,
            params: { matchId: item.matchId }
          })
          if (data.data) {
            await this.$store.commit('updateracedetails', data.data)
          } else {
            await this.$store.commit('updateracedetails', {})
          }
        } catch (e) {
          await this.$store.commit('updateracedetails', {})
        }
        this.$router.push({ name: 'raceDetails' })
      },

      // 前往赛事中心（更多赛事）
      tomatch() {
        document.documentElement.scrollTop = 0
        this.$store.commit('updatetabIndexActive', '3')
        this.$router.push({ path: '/move' })
      },

      // 统一列表点击分发：公告→公告详情，新闻→新闻详情（含外链直跳）
      openInfo(item) {
        if (item.type === 'notice') {
          this.getnoticedetailsdata(item.raw)
        } else {
          this.getnewsdetailsdata(item.raw)
        }
      },

      async getnoticedetailsdata(item) {
        // 请求列表详情数据
        const { data } = await request({
          method: "POST",
          url: `/common/NoticeInfo/getInfo`,
          params: { id: item.noticeId }
        })
        // 存入vuex
        if (data.data) {
          await this.$store.commit("updateNoticedetails", data.data)
        } else {
          await this.$store.commit("updateNoticedetails", {})
        }
        // 将 index索引值存入vuex
        this.$store.commit("updatetabIndexActive", "2")
        document.documentElement.scrollTop = 0
        // 跳转路由
        this.$router.push({ path: '/Noticedetails' })
      },
 async getnewsdetailsdata(obj) {
        if(obj.newsLink) {
      // 如果有新闻链接 则直接跳转
      window.open(obj.newsLink, "_blank");
      } else {
        // 请求列表详情数据
        const {
          data
        } = await request({
          method: "POST",
          url: `/common/NewsInfo/getInfo`,
          params: {
            id: obj.newId
          }
        })
        console.log("获取新闻详情成功")
        console.log(data.data)
        // 存入vuex
        if (data.data) {
          // 如果详情对象有值 则将该机构详情对象数据存储到vuex中 供机构详情页使用
          await this.$store.commit("updatenewsdetails", data.data)
        } else {
          // 如果详情对象无值 则传入空对象
          await this.$store.commit("updatenewsdetails", {})
        }
        // 将 index索引值存入vuex
        this.$store.commit("updatetabIndexActive", "4")
        // 跳转路由
        this.$router.push({
          path: '/newsdetails'
        })
      }
      },

      // 获取banner图
      async getbanner() {
        try {
          const {
            data
          } = await request({
            url: `/common/BannerInfo/list`,
            method: "POST",
            params:{
            client:'pc'
          }
          })
          if (data.code === 200 && data.rows) {
            this.imgone = data.rows
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取数据失败")
          }

        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },
      // 获取合作伙伴图
      async getPartner() {
        try {
          const {
            data
          } = await request({
            url: `/common/partner/list`,
            method: "GET",
          })
          if (data.code === 200 && data.rows) {
            this.imgtwo = data.rows
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取数据失败")
          }

        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },




      tonotice() {
        // 先滚动置0 再跳转路由（指向"新闻公告"统一页面的"协会公告"分类）
        document.documentElement.scrollTop = 0
        this.$store.commit("updatetabIndexActive", "2")
        this.$router.push({
          path: "/newsnotice",
          query: { tab: "notice" }
        })
      },
      tonews() {
        // 先滚动置0 再跳转路由（指向"新闻公告"统一页面的"新闻专区"分类）
        document.documentElement.scrollTop = 0
        this.$store.commit("updatetabIndexActive", "2")
        this.$router.push({
          path: "/newsnotice",
          query: { tab: "news" }
        })
      },
      goEchelon() {
        this.$router.push('/echelon')
      },
      goCertificate() {
        this.$router.push('/certificate')
      },
      goKnowledge() {
        this.$router.push('/knowledge')
      },
      goCertApply() {
        this.$router.push('/certApply')
      },
      // 轮播图点击跳转事件
      go(type) {
        if (type === "prev") {
          this.$refs.cardshow.prev()
        } else {
          this.$refs.cardshow.next()
        }
      },
      // 轮播图点击跳转
      topage(item) {
        document.documentElement.scrollTop = 0
        window.open(item.linkPath)
        // if (id == 1) {
        //   document.documentElement.scrollTop = 0
        //   this.$router.push({ path: "/Notice" })
        //   this.$store.commit("updatetabIndexActive", "2")
        // }
        // if (id == 3) {
        //   document.documentElement.scrollTop = 0
        //   // 调用a链接（众弈世界）的点击事件
        //   this.$refs.aclick.click()
        // }
        // if (id == 2 || id == 4) {
        //   document.documentElement.scrollTop = 0
        //   this.$router.push({ path: "/move" })
        //   this.$store.commit("updatetabIndexActive", "3")
        // }
      },
      //合作伙伴跳转  window.location.href = "https://www.sport.gov.cn/"
      toLink(name) {
        window.open(name)
      },
    },
  }

</script>

<style lang="less" scoped>
.queryFixed {
  position: fixed;
  left: 5px;
  top: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-color: var(--ts-primary);
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.queryFixed:hover {
  background-color: var(--ts-primary-hover);
}

// #FE80B1, #1E40AF
// .home{
//background-color: #EFEFEF;
// }
.green {
  color: var(--ts-accent);
}

// 顶部轮播图样式
.maininfo {
  display: block;
  background-color: #fff;
}

// 轮播图外层约束框：普通 div，max-width 走 rem 缩放，块级水平居中
.banner-wrap {
  display: block;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

// 轮播图撑满 .banner-wrap
.banner-wrap .el-carousel {
  display: block;
  width: 100%;
}

.el-carousel__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

::v-deep .el-carousel__container {
  width: 100%;
  height: 375px;
  // width: 1920px;
  // min-height: 600px;
}

/deep/ .maininfo .el-carousel__arrow--left {
  width: 40px;
}

/deep/ .maininfo .el-carousel__arrow--right {
  width: 40px;
}

/deep/ .maininfo .el-icon-arrow-left {
  font-size: 30px;
}

/deep/ .maininfo .el-icon-arrow-right {
  font-size: 30px;
}

// 顶部轮播图样式

// 公告新闻列表样式↓↓↓
.listinfo {
  background-color: #ffffff;
  margin: 25px 0px;
  padding: 45px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.widthSet {
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

/* ===== 双栏布局（左：赛事专区新闻 / 右：资讯动态） ===== */
.infocenter,
.match-news {
  max-width: 100%;
}

/* 赛事专区新闻（左栏） */
.match-news {
  flex: 1;
  min-width: 0;

  /* 适应窄栏：头部宽度铺满 */
  .top {
    width: 100%;
  }
}

/* 统一资讯列表：公告与新闻合并为单列，置于右栏 */
.infocenter {
  flex: 1;
  min-width: 0;
  margin: 0;

  .top {
    width: 100%;
  }

  /* 双入口：公告列表 / 新闻列表 */
  .rightson-group {
    display: flex;
    align-items: center;
    gap: 28px;
  }

  .rightson {
    cursor: pointer;
  }
}

/* 赛事新闻列表行 */
.matchnotice {
  margin: 20px 0px 30px;
}

.matchnotice li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 0px 20px;
  height: 60px;
  font-size: 20px;
  color: var(--ts-on-primary);
  background-color: var(--ts-primary);
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.matchnotice li:hover {
  background-color: var(--ts-primary-hover);
  transform: translateY(-2px);
}

/* 赛事状态标签 */
.match-status {
  flex-shrink: 0;
  padding: 3px 10px;
  font-size: 13px;
  font-weight: bold;
  border-radius: 4px;
  letter-spacing: 1px;
  color: #ffffff;
  white-space: nowrap;
}

.match-status.mst-1 {
  background-color: #16a34a;
}

.match-status.mst-2 {
  background-color: #2563eb;
}

.match-status.mst-3 {
  background-color: #9ca3af;
}

/* 类型标签：置于标题前方，颜色区分 */
.info-tag {
  flex-shrink: 0;
  padding: 3px 10px;
  font-size: 13px;
  font-weight: bold;
  border-radius: 4px;
  letter-spacing: 1px;
}

.info-tag.tag-notice {
  color: #7c4a03;
  background-color: #fde8c8;
  border: 1px solid #f3c98b;
}

.info-tag.tag-news {
  color: #0d5b46;
  background-color: #d8f2e8;
  border: 1px solid #a9e0cf;
}

.info-tag.tag-match {
  color: #9a3412;
  background-color: #ffedd5;
  border: 1px solid #f5c99a;
}

.infodate {
  flex-shrink: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
}

@keyframes myfirst {
  0% {
    opacity: 0;
    margin-top: 150px;
  }

  25% {
  }

  50% {
  }

  75% {
  }

  100% {
    margin-top: 0px;
    //  transform:rotateY(180deg);
    //  -webkit-transform: rotateY(360deg); /* Safari 与 Chrome */
    //  opacity: 1;
  }
}

.infocenter,
.left,
.right {
  animation: myfirst 1.5s;
  -moz-animation: myfirst 1.5s;
  /* Firefox */
  -webkit-animation: myfirst 1.5s;
  /* Safari and Chrome */
  -o-animation: myfirst 1.5s;
  /* Opera */
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 580px;
}

.leftson {
  text-align: start;
}

.leftson h3 {
  font-size: 30px;
}

.leftson p {
  font-size: 24px;
  font-weight: bold;
}

.rightson {
  display: flex;
  align-items: center;
}

.rightson p {
  font-size: 20px;
  margin-right: 6px;
  font-weight: bold;
}

.rightson button {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid var(--ts-primary);
  background-color: white;

  i {
    padding-top: 2px;
    padding-left: 2px;
  }
}

.newnotice {
  margin: 20px 0px 30px;
}

.newnotice li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 0px 20px;
  // width: 650px;
  height: 60px;
  font-size: 20px;
  color: var(--ts-on-primary);
  background-color: var(--ts-primary);
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.newnotice li:hover {
  background-color: var(--ts-primary-hover);
  transform: translateY(-2px);
}

// .newnotice li:last-child {
//   margin-bottom: 0px;
// }

// 公告新闻列表样式↑↑↑

// 成果展示（滚动照片） ↓↓↓
.achievementinfo {
  background-color: #ffffff;
  margin: 25px 0px;
  padding: 35px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ach-wrap {
  width: 100%;
  max-width: 1440px;
}

.ach-marquee {
  overflow: hidden;
}

.ach-track {
  display: flex;
  gap: 16px;
  width: max-content;
  animation: achScroll 30s linear infinite;
}

@keyframes achScroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.ach-marquee:hover .ach-track {
  animation-play-state: paused;
}

.ach-item {
  width: 320px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 320px;
    object-fit: cover;
    display: block;
  }

  .ach-title {
    display: block;
    padding: 8px 12px;
    font-size: 15px;
    color: #333;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

// 成果展示（滚动照片） ↑↑↑

// 四大专栏入口 ↓↓↓
.columns {
  background: linear-gradient(180deg, #f4f7ff 0%, #ffffff 100%);
  margin: 25px 0px;
  padding: 50px 0px;
  display: flex;
  justify-content: center;
}

.columns-inner {
  width: 100%;
  max-width: 1440px;
}

.columns-head {
  text-align: center;
  margin-bottom: 36px;

  h3 {
    font-size: 32px;
    color: var(--ts-text);
  }

  p {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--ts-muted);
    margin-top: 4px;
  }
}

.columns-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.column-card {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eef2fb;
  border-radius: 16px;
  padding: 28px 26px 26px;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, var(--ts-primary), var(--ts-secondary));
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 18px 36px rgba(30, 64, 175, 0.16);

    &::after {
      opacity: 1;
    }

    .col-arrow {
      background: var(--ts-primary);
      border-color: var(--ts-primary);
      color: #fff;
      transform: translateX(2px);
    }
  }
}

.col-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.col-ico {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 30px;
    color: #ffffff;
  }
}

.ico-blue { background: linear-gradient(135deg, #2563eb, #3b82f6); }
.ico-green { background: linear-gradient(135deg, #16a34a, #4ade80); }
.ico-teal { background: linear-gradient(135deg, #0d9488, #2dd4bf); }
.ico-amber { background: linear-gradient(135deg, #d97706, #fbbf24); }

.col-arrow {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--ts-muted);
  transition: all 0.3s ease;

  i {
    font-size: 16px;
  }
}

.column-card h4 {
  font-size: 20px;
  font-weight: 700;
  color: var(--ts-text);
}

.col-en {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: var(--ts-muted);
  margin-top: 4px;
  text-transform: uppercase;
}

.col-desc {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ts-muted);
  margin-top: 12px;
  min-height: 44px;
}

// 专栏入口响应式
@media (max-width: 1000px) {
  .columns-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .columns-grid {
    grid-template-columns: 1fr;
  }
}
// 四大专栏入口 ↑↑↑

// 合作伙伴 ↓↓↓
.partinfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 150px;
  background-image: url(../assets/css/img/bg.jpg);
}

.partinfo p {
  font-size: 35px;
  color: #ffffff;
}

.partinfo p:last-child {
  font-size: 24px;
}

// 合作伙伴 ↑↑↑

// 底部轮播图待替换 ↓↓↓
.footerinfo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 260px;
  background-color: #ffffff;

  margin: 25px 0px;
}

// 静态ul li
.footul {
  height: 220px;
  display: flex;
  width: 100%;
  max-width: 1440px;
  // justify-content: flex-start;
}

.footli {
  background-color: white;
  height: 220px;
  width: 240px;
  // width: 100px;
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
  align-items: center;
  justify-content: center;

  .partnerName {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
}

.footli img {
  width: 190px;
  -webkit-transition: width 0.8s;
  /* For Safari 3.1 to 6.0 */
  transition: width 0.8s;
}

.footli img:hover {
  width: 240px;

  // background-image: linear-gradient(to right, #FE80B1,rgba(0,0,0,0) , #1E40AF,);
}

.footli:hover {
  border-bottom: 2px solid var(--ts-primary);
}

// 轮播图
.footerinfo .prev {
  width: 60px;
  height: 60px;
  border: 1px solid white;
  margin-right: 109px;
  line-height: 60px;
}

.footerinfo .prev .el-icon-arrow-left {
  font-size: 20px;
}

.footerinfo .next {
  width: 60px;
  height: 60px;
  border: 1px solid white;
  margin-left: 109px;
  line-height: 60px;
}

.footerinfo .next .el-icon-arrow-right {
  font-size: 20px;
}

.footerinfo .prev button,
.footerinfo .next button {
  width: 60px;
  height: 60px;
}

// 轮播图具体样式  轮播图样式调整思路
// 标签上的高度、.el-carousel的宽度、.el-carousel__item及.el-carousel__container的宽高
.footerinfo .el-carousel {
  width: 260px;
}

//  .footerinfo .el-carousel .el-carousel__item{
//   //  height: 100px;
//   //  width: 100px;
//  }

// 底部轮播图 待替换↑↑↑
.maxwidth {
  flex: 1;
  min-width: 0;
  text-align: left;
  widows: 100%;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

/* ============ 中等屏（平板/小笔记本）：双栏改为上下堆叠 ============ */
@media (max-width: 1360px) {
  .widthSet {
    flex-direction: column;
    align-items: center;
    gap: 36px;
  }

  .match-news {
    flex: none;
    width: 100%;
    max-width: 900px;
  }

  .infocenter {
    flex: none;
    width: 100%;
    max-width: 900px;
  }
}

/* ============ 移动端首页布局 ============ */
@media (max-width: 768px) {
  /* 顶部轮播：降低高度，铺满 */
  .maininfo {
    padding: 0;
  }

  :deep(.el-carousel__container),
  :deep(.el-carousel__item) {
    height: 190px !important;
  }

  /* 指示点贴底，避免悬空 */
  :deep(.el-carousel__indicators--outside) {
    margin-top: -14px;
  }

  /* 公告/新闻：上下堆叠 */
  .listinfo {
    height: auto;
    padding: 24px 0;
    margin: 12px 0;
  }

  .widthSet {
    flex-direction: column;
    gap: 30px;
  }

  .infocenter {
    flex: none;
    width: 100%;
  }

  /* 赛事专区新闻（左栏）：移动端铺满 */
  .match-news {
    flex: none;
    width: 100%;
    margin-bottom: 6px;
  }

  .match-news .leftson h3 {
    font-size: 22px;
  }

  .match-news .leftson p {
    font-size: 16px;
  }

  .matchnotice li {
    height: auto;
    min-height: 48px;
    padding: 10px 14px;
    font-size: 15px;
    gap: 10px;
    flex-wrap: wrap;
  }

  .matchnotice li p {
    font-size: 15px;
    line-height: 1.4;
  }

  .match-status {
    font-size: 12px;
    padding: 2px 8px;
  }

  .top {
    width: 100%;
  }

  .leftson h3 {
    font-size: 22px;
  }

  .leftson p {
    font-size: 16px;
  }

  .rightson-group {
    gap: 16px;
  }

  .rightson p {
    font-size: 14px;
  }

  .newnotice li {
    height: auto;
    min-height: 48px;
    padding: 10px 14px;
    font-size: 15px;
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .newnotice li p {
    font-size: 15px;
    line-height: 1.4;
  }

  .newnotice li .infodate {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    align-self: flex-end;
  }

  .info-tag {
    font-size: 12px;
    padding: 2px 8px;
  }

  .maxwidth {
    width: 100%;
    white-space: normal;
  }

  /* 专栏：单列 + 卡片紧凑 */
  .columns {
    padding: 28px 12px;
    margin: 12px 0;
  }

  .columns-head {
    margin-bottom: 20px;
  }

  .columns-head h3 {
    font-size: 24px;
  }

  .columns-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .column-card {
    padding: 18px 18px 16px;
  }

  .column-card h4 {
    font-size: 18px;
  }

  .col-desc {
    min-height: 0;
    font-size: 13px;
  }

  .col-ico {
    width: 48px;
    height: 48px;
  }

  .col-ico i {
    font-size: 24px;
  }

  /* 成果展示：缩小卡片 */
  .achievementinfo {
    margin: 12px 0;
    padding: 22px 0;
  }

  .ach-item {
    width: 210px;
  }

  .ach-item img {
    height: 210px;
  }

  /* 合作伙伴标题 */
  .partinfo {
    height: auto;
    padding: 28px 12px;
  }

  .partinfo p {
    font-size: 22px;
  }

  .partinfo p:last-child {
    font-size: 15px;
  }

  /* 底部合作伙伴：换行 */
  .footerinfo {
    height: auto;
    margin: 12px 0;
    padding: 18px 12px;
  }

  .footul {
    height: auto;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }

  .footli {
    width: 40%;
    height: auto;
    max-width: 180px;
  }

  .footli img {
    width: 120px;
  }
}

</style>





